import type { CursorList } from "../lib/useCursorList";

type PagerState = Pick<CursorList<unknown>, "page" | "first" | "last" | "hasNewer" | "hasOlder" | "loading" | "newAbove" | "newer" | "older" | "toFirst">;

/** "Showing 26–50"; one row: "Showing 26"; nothing while no row is shown. */
export function showing(first: number, last: number): string {
  if (first === 0) return "";
  return first === last ? `Showing ${first}` : `Showing ${first}–${last}`;
}

/** On an older page, when page one has gained rows since it was shown. Drawn above the list. */
export function NewAbove({ list, noun }: { list: PagerState; noun: string }) {
  if (list.page === 0 || !list.newAbove) return null;
  return (
    <div className="mk-pager-new-wrap" aria-live="polite">
      <button type="button" className="mk-pager-new" onClick={list.toFirst} aria-label={`New ${noun} above: show the newest page`}>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M6 10V2M2.5 5.5L6 2l3.5 3.5" />
        </svg>
        New {noun} above
      </button>
    </div>
  );
}

/** Drawn under the list: where it ends, and the step to newer or older rows. No list prints a total. */
export function Pager({ list, noun }: { list: PagerState; noun: string }) {
  return (
    <>
      {list.page > 0 && !list.hasOlder && <p className="mk-pager-end">No older {noun}.</p>}
      <nav className="mk-pager" aria-label={`Pages of ${noun}`}>
        <span className="mk-pager-showing" aria-live="polite">
          {showing(list.first, list.last)}
        </span>
        <button type="button" className="mk-btn" disabled={!list.hasNewer || list.loading} onClick={list.newer}>
          ← Newer
        </button>
        <button type="button" className="mk-btn" disabled={!list.hasOlder || list.loading} onClick={list.older}>
          Older →
        </button>
      </nav>
    </>
  );
}
